import * as React from 'react';
import {
  Box,
} from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';


import { AboutUsComp, AboutUsContent, DivContent, OrcamentoButton, TextBody, TextContent, TextDiv, TextTitle, Vantagens, VideoContent } from './styles';
const NossaSolucao: React.FC = () => {
  return (
    <AboutUsComp id='nossol'>
      <AboutUsContent>
                <TextContent id='sobrelp'>
                  <Vantagens>
                    <CreateIcon
                      sx={{ color: "#f5bb12",  '& path': {
                        stroke: 'black',
                        strokeWidth: 2,
                      }}}
                    />
                    <p>Vantagens</p>
                  </Vantagens>
                  <TextTitle>
                    <h1>O QUE TORNA OS PRODUTOS DO BHBUS MÍDIA UMA ESTRATÉGIA PODEROSA?</h1>
                    <h2>Backbus • Busdoor • Backseat • Envelopamento</h2>
                  </TextTitle>
                  <OrcamentoButton
                    href="https://api.whatsapp.com/send?phone=553131983024595&text=Ol%C3%A1,%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20BHBus%20M%C3%ADdia%20"
                    target='_blank'
                  >
                    Solicite um orçamento
                  </OrcamentoButton>
                </TextContent>
                <DivContent>
                  <TextDiv>
                    <p>
                      Diferente de outras mídias OOH, <strong>sua marca não disputa espaço, ela se destaca por onde passa!</strong>
                    </p>
                  </TextDiv>
                  <TextDiv>
                    <p>
                      <strong>Somos exclusivos </strong>oferecendo esse tipo de mídia em BH.
                    </p>
                  </TextDiv>
                  <TextDiv>
                    <p>
                      <strong>
                        Com cobertura bairro a bairro
                        </strong>
                        , a mídia ônibus circula por toda Belo Horizonte 
                        <strong>
                          , garantindo que sua marca seja vista em diferentes regiões da cidade.
                        </strong>
                    </p>
                  </TextDiv>
                  <TextDiv>
                    <p>A Mídia Ônibus <strong>é a melhor de BH em OOH.</strong></p>
                  </TextDiv>
                </DivContent>
      </AboutUsContent>
    </AboutUsComp>
  );
};

export { NossaSolucao };